/* Moved out of sections/header.liquid on 1 Nov 2026 (Alex: "my site is so slow"): this 34 KB script was inline in
   every page's HTML. As a theme asset it is downloaded once and cached across pages; `defer` keeps it running
   after the header markup exists, as the inline copy did. Source of truth is this file now. */
            /* Search pill behaviour (21 Sep 2026): full-screen state on phones
               while the field has focus, back arrow / clear ✕, page scroll lock.
               Lives here rather than in predictive-search.js (that asset is built
               from src/scripts/features/predictive-search.ts).
               BUG-014 dismiss rules (23 Sep 2026) — the suggestions must always be
               closable: (1) a pointerdown ANYWHERE outside the search element
               (capture phase, so no widget's stopPropagation can swallow it; taps
               inside an iframe never reach this document — rule 4 covers those)
               dismisses at every width; (2) on phones the element is full-screen
               while focused, so a tap on its blank area — anything that is not the
               field, its back/clear buttons, the suggestions list or the search-home
               panel — dismisses too; (3) Escape dismisses; (4) the window losing
               focus (iframe, other tab) dismisses; (5) the element's own
               `predictive-search:dismiss` event (Escape inside the field) clears
               the focused state here. Dismiss keeps the typed text; the ✕ clears it. */
            (function () {
              var ps = document.querySelector('predictive-search.vpb-search-pill');
              if (!ps) return;
              var input = ps.querySelector('input[type="search"]');
              var back = ps.querySelector('.vpb-search-pill__back');
              var clr = ps.querySelector('.vpb-search-pill__clear');
              var mq = window.matchMedia('(max-width: 989px)');
              function setFocused(on) {
                ps.classList.toggle('is-focused', on);
                document.documentElement.classList.toggle('vpb-search-open', on && mq.matches);
              }
              function syncClear() { ps.classList.toggle('has-text', !!(input && input.value)); }
              if (!input) return;
              input.addEventListener('focus', function () { setFocused(true); syncClear(); });
              /* scope pills: Cards / Gifts / Flowers narrow the submitted search via
                 Shopify's product_type query syntax; the results heading strips the clause */
              var SCOPE_Q = { cards: ' product_type:"Greeting Card"', gifts: ' -product_type:"Greeting Card" -product_type:Flowers', flowers: ' product_type:Flowers' };
              var scope = '';
              ps.querySelectorAll('.vpb-sh__scope').forEach(function (b) {
                b.addEventListener('click', function (e) {
                  e.preventDefault(); scope = b.getAttribute('data-scope') || '';
                  ps.querySelectorAll('.vpb-sh__scope').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
                  input.focus();
                });
              });
              var form = ps.querySelector('form.search');
              /* Enter goes to a COLLECTION when the typed term is that collection's name
                 (Alex, 21 Sep 2026: "even if I press Enter, that should be a collection").
                 Match rule: normalise both (lowercase, strip punctuation/spaces) and
                 accept equality, or equality once "cards"/"gifts" is dropped from either
                 side. Uses the dropdown's rendered collection rows when it has them,
                 otherwise one quick suggest.json call (700 ms cap) before falling back
                 to the normal /search submit. Scope pills (Cards/Gifts/Flowers) skip this. */
              var norm = function (t) { return String(t || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ''); };
              var strip = function (t) { return norm(t).replace(/(cards?|gifts?)$/, ''); };
              var collMatch = function (q, title) { var a = norm(q), b = norm(title); if (!a || !b) return false; return a === b || strip(q) === strip(title); };
              /* ── Typed query → filter facets (Parity Index W4, 21 Sep 2026) ───────
                 "funny 40th sister" is a three-filter intent, not a keyword search:
                 Shopify relevance cannot answer it, the filter bar can. The query is
                 read against the same vocabularies sections/ll-mp-filters.liquid
                 renders (who / age / stage / tone / style / topic / photos) plus the
                 occasion collections, and when enough of it is recognised we go
                 straight to that collection with the pills already applied, e.g.
                 /collections/birthdays?mpf=who:Sister;age:40th%20birthday;tone:Funny
                 — the filter section reads ?mpf= on load. Anything not recognised
                 falls through to the collection-name match and predictive search
                 below, unchanged. Safety valve: a gift-line word (flowers, wine,
                 hamper…) with no occasion and nothing else recognised never
                 redirects — someone typing "flowers" wants the flowers, not floral
                 birthday cards. */
              /* Style and Topic tags do not exist on the catalogue yet (the labeller
                 fills them in W1). Until they do, those words must not be recognised
                 at all — filtering on a tag nothing carries returns an empty grid —
                 so the vocabulary stays below but drops out of FQ_LIST. Flip to true
                 in the push that follows the labelling run. */
              var FQ_STYLE_TOPIC = true; // flipped 21 Sep 2026 23:40 — Style/Topic tags now on all birthday cards (filter-style-topic-fill.mjs)
              var FQ_STOPS = ' for a an the an my me to of and with on in some please ';
              /* words that name a product line rather than a card subject. These veto
                 the redirect outright, however much else matched and occasion or no
                 occasion: the shop sells balloons, flowers and hampers, so "50th
                 birthday balloons" and "christmas hamper for dad" are product
                 searches, not card filters. */
              var FQ_GIFTY = /\b(flowers?|bouquets?|gifts?|presents?|hampers?|mugs?|balloons?|candles?|plants?|wine|beer|gin|whisky|whiskey|prosecco|champagne|sweets|teddy|vitamins|supplements|chocolates?)\b/;
              /* milestone values exactly as GROUPS.age renders them in ll-mp-filters.liquid */
              var FQ_AGES = ['1st birthday','2nd birthday','3rd birthday','4th birthday','5th birthday','6th birthday','7th birthday','8th birthday','9th birthday','10th birthday','11th birthday','12th birthday','13th birthday','14th birthday','15th birthday','16th birthday','17th birthday','18th birthday','19th birthday','20th birthday','21st birthday','25th birthday','30th birthday','35th birthday','40th birthday','45th birthday','50th birthday','55th birthday','60th birthday','65th birthday','70th birthday','75th birthday','80th birthday','85th birthday','90th birthday','95th birthday','100th birthday'];
              /* [phrase, group, value] — group 'occ' carries a collection handle
                 (every handle checked against templates/product.quickview.liquid) */
              var FQ_TERMS = [
                ['birthday','occ','birthdays'],['birthdays','occ','birthdays'],['bday','occ','birthdays'],['bdays','occ','birthdays'],
                ['anniversary','occ','anniversary'],['anniversaries','occ','anniversary'],
                ['wedding','occ','weddings'],['weddings','occ','weddings'],['marriage','occ','weddings'],
                ['new baby','occ','new-baby'],['newborn','occ','new-baby'],['baby','occ','new-baby'],
                ['christmas','occ','christmas'],['xmas','occ','christmas'],
                ['engagement','occ','engagement'],['engaged','occ','engagement'],
                ['thank you','occ','thank-you'],['thanks','occ','thank-you'],['thankyou','occ','thank-you'],
                ['sympathy','occ','sympathy'],['condolence','occ','sympathy'],['condolences','occ','sympathy'],['bereavement','occ','sympathy'],
                ['congratulations','occ','congratulations'],['congrats','occ','congratulations'],['well done','occ','congratulations'],
                ['get well soon','occ','get-well-soon'],['get well','occ','get-well-soon'],
                ['good luck','occ','good-luck'],
                ['new home','occ','new-home'],['housewarming','occ','new-home'],['house warming','occ','new-home'],['new house','occ','new-home'],
                ['new job','occ','new-job'],
                ['leaving','occ','leaving'],['farewell','occ','leaving'],
                ['fathers day','occ','fathers-day'],['father day','occ','fathers-day'],['dads day','occ','fathers-day'],['dad day','occ','fathers-day'],
                ['halloween','occ','halloween'],
                ['exam','occ','exams'],['exams','occ','exams'],
                ['friendship','occ','friendship'],
                ['thinking of you','occ','thinking-of-you'],
                ['just because','occ','just-because'],
                ['back to school','occ','back-to-school'],
                ['retirement','occ','retirement'],['retiring','occ','retirement'],
                ['graduation','occ','graduation'],['graduating','occ','graduation'],
                ['christening','occ','christening'],
                ['easter','occ','easter'],
                ['pregnancy','occ','pregnancy'],['pregnant','occ','pregnancy'],
                ['divorce','occ','divorce'],

                ['great granddaughter','who','Great Granddaughter'],['great grand daughter','who','Great Granddaughter'],
                ['great grandson','who','Great Grandson'],['great grand son','who','Great Grandson'],
                ['great grandma','who','Great Grandma'],['great granny','who','Great Grandma'],['great grandmother','who','Great Grandma'],
                ['great grandad','who','Great Grandad'],['great granddad','who','Great Grandad'],['great grandpa','who','Great Grandad'],['great grandfather','who','Great Grandad'],
                ['sister in law','who','Sister In Law'],['sister inlaw','who','Sister In Law'],
                ['brother in law','who','Brother in Law'],['brother inlaw','who','Brother in Law'],
                ['daughter in law','who','Daughter in Law'],['daughter inlaw','who','Daughter in Law'],
                ['son in law','who','Son in Law'],['son inlaw','who','Son in Law'],
                ['mother in law','who','Mother in Law'],['mother inlaw','who','Mother in Law'],['mum in law','who','Mother in Law'],
                ['father in law','who','Father in Law'],['father inlaw','who','Father in Law'],['dad in law','who','Father in Law'],
                ['best friend','who','Best friend'],['best mate','who','Best friend'],['bestie','who','Best friend'],['bff','who','Best friend'],
                ['step dad','who','Step Dad'],['stepdad','who','Step Dad'],['step father','who','Step Dad'],
                ['step mum','who','Step Mum'],['stepmum','who','Step Mum'],['step mom','who','Step Mum'],['step mother','who','Step Mum'],
                ['god daughter','who','Goddaughter'],['goddaughter','who','Goddaughter'],
                ['god son','who','Godson'],['godson','who','Godson'],
                ['god mother','who','Godmother'],['godmother','who','Godmother'],
                ['god father','who','Godfather'],['godfather','who','Godfather'],
                ['grand daughter','who','Granddaughter'],['granddaughter','who','Granddaughter'],
                ['grand son','who','Grandson'],['grandson','who','Grandson'],
                ['grandma','who','Grandma'],['grandmother','who','Grandma'],['gran','who','Grandma'],['granny','who','Grandma'],['nan','who','Grandma'],['nana','who','Grandma'],['nanny','who','Grandma'],
                ['grandad','who','Grandad'],['granddad','who','Grandad'],['grandpa','who','Grandad'],['grandfather','who','Grandad'],
                ['auntie','who','Auntie'],['aunty','who','Auntie'],['aunt','who','Auntie'],
                ['boyfriend','who','Boyfriend'],['bf','who','Boyfriend'],
                ['girlfriend','who','Girlfriend'],['gf','who','Girlfriend'],
                ['brother','who','Brother'],['bro','who','Brother'],
                ['sister','who','Sister'],['sis','who','Sister'],
                ['colleague','who','Colleague'],['coworker','who','Colleague'],['co worker','who','Colleague'],
                ['cousin','who','Cousin'],
                ['daughter','who','Daughter'],
                ['son','who','Son'],
                ['husband','who','Husband'],['hubby','who','Husband'],
                ['wife','who','Wife'],['wifey','who','Wife'],
                ['mum','who','Mum'],['mom','who','Mum'],['mummy','who','Mum'],['mommy','who','Mum'],['mother','who','Mum'],['mam','who','Mum'],
                ['dad','who','Dad'],['daddy','who','Dad'],['father','who','Dad'],['papa','who','Dad'],
                ['nephew','who','Nephew'],
                ['niece','who','Niece'],
                ['partner','who','Partner'],
                ['friend','who','Friend'],
                ['teacher','who','Teacher'],
                ['uncle','who','Uncle'],
                ['her','who','For Her'],['she','who','For Her'],['women','who','For Her'],['woman','who','For Her'],['ladies','who','For Her'],['lady','who','For Her'],
                ['him','who','For Him'],['he','who','For Him'],['men','who','For Him'],['man','who','For Him'],
                ['kids','who','For Kids'],['children','who','For Kids'],['child','who','For Kids'],
                ['girls','who','For Girls'],['girl','who','For Girls'],
                ['boys','who','For Boys'],['boy','who','For Boys'],

                ['eighteenth','age','18th birthday'],['sixteenth','age','16th birthday'],['twenty first','age','21st birthday'],['twentyfirst','age','21st birthday'],
                ['thirtieth','age','30th birthday'],['fortieth','age','40th birthday'],['fiftieth','age','50th birthday'],['sixtieth','age','60th birthday'],
                ['seventieth','age','70th birthday'],['eightieth','age','80th birthday'],['ninetieth','age','90th birthday'],['hundredth','age','100th birthday'],

                ['funny','tone','Funny'],['humorous','tone','Funny'],['joke','tone','Funny'],['jokes','tone','Funny'],['hilarious','tone','Funny'],['witty','tone','Funny'],
                ['rude','tone','Rude'],['naughty','tone','Rude'],
                ['cheeky','tone','Cheeky'],
                ['romantic','tone','Romantic'],['love','tone','Romantic'],
                ['heartfelt','tone','From the heart'],['sentimental','tone','From the heart'],
                ['sympathetic','tone','Sympathetic'],
                ['uplifting','tone','Uplifting'],
                ['empowering','tone','Empowering'],
                ['celebratory','tone','Celebratory'],
                ['across the miles','tone','Across the Miles'],['miss you','tone','Across the Miles'],['missing you','tone','Across the Miles'],['far away','tone','Across the Miles'],
                ['verse','tone','Verse'],['poem','tone','Verse'],['rhyme','tone','Verse'],

                ['photo collage','style','Photo collage'],
                ['cute','style','Cute'],
                ['floral','style','Floral'],['flowery','style','Floral'],['flowers','style','Floral'],['flower','style','Floral'],
                ['retro','style','Retro'],['vintage','style','Retro'],
                ['cartoon','style','Cartoon'],
                ['pun','style','Pun'],['puns','style','Pun'],
                ['minimal','style','Minimalist'],['minimalist','style','Minimalist'],['simple','style','Minimalist'],
                ['typography','style','Typography'],['text','style','Typography'],
                ['illustrated','style','Illustration'],['illustration','style','Illustration'],
                ['colourful','style','Colourful'],['colorful','style','Colourful'],
                ['modern','style','Modern'],
                ['artistic','style','Artistic'],
                ['character','style','Character'],
                ['photographic','style','Photographic'],
                ['classic','style','Classic'],
                ['traditional','style','Traditional'],

                ['no photos','photos','No photos'],['no photo','photos','No photos'],
                ['photo','photos','1 photo'],['photos','photos','1 photo'],['picture','photos','1 photo'],['pictures','photos','1 photo'],

                ['food and drink','topic','Food and Drink'],['food','topic','Food and Drink'],['foodie','topic','Food and Drink'],['wine','topic','Food and Drink'],['beer','topic','Food and Drink'],['gin','topic','Food and Drink'],['coffee','topic','Food and Drink'],['cake','topic','Food and Drink'],
                ['tv and film','topic','TV & Film'],['film','topic','TV & Film'],['films','topic','TV & Film'],['movie','topic','TV & Film'],['movies','topic','TV & Film'],['tv','topic','TV & Film'],
                ['cars and bikes','topic','Cars and Bikes'],['car','topic','Cars and Bikes'],['cars','topic','Cars and Bikes'],['bike','topic','Cars and Bikes'],['bikes','topic','Cars and Bikes'],['motorbike','topic','Cars and Bikes'],['motorbikes','topic','Cars and Bikes'],
                ['animals','topic','Animals'],['animal','topic','Animals'],
                ['dog','topic','Dogs'],['dogs','topic','Dogs'],['puppy','topic','Dogs'],['puppies','topic','Dogs'],
                ['cat','topic','Cats'],['cats','topic','Cats'],['kitten','topic','Cats'],['kittens','topic','Cats'],
                ['football','topic','Football'],['footy','topic','Football'],['soccer','topic','Football'],
                ['gaming','topic','Gaming'],['gamer','topic','Gaming'],['games','topic','Gaming'],['game','topic','Gaming'],
                ['gardening','topic','Gardening'],['garden','topic','Gardening'],['gardener','topic','Gardening'],
                ['music','topic','Music'],['musician','topic','Music'],
                ['space','topic','Space'],['astronaut','topic','Space'],
                ['dinosaur','topic','Dinosaur'],['dinosaurs','topic','Dinosaur'],['dino','topic','Dinosaur'],
                ['unicorn','topic','Unicorn'],['unicorns','topic','Unicorn'],
                ['fitness','topic','Fitness'],['gym','topic','Fitness'],['running','topic','Fitness'],['runner','topic','Fitness'],
                ['bird','topic','Bird'],['birds','topic','Bird'],['birdwatching','topic','Bird'],
                ['butterfly','topic','Butterfly'],['butterflies','topic','Butterfly'],
                ['rabbit','topic','Rabbit'],['rabbits','topic','Rabbit'],['bunny','topic','Rabbit'],
                ['pig','topic','Pig'],['pigs','topic','Pig'],
                ['fish','topic','Fish'],['fishing','topic','Fish'],
                ['bear','topic','Bear'],['bears','topic','Bear'],
                ['pet','topic','Pet'],['pets','topic','Pet'],
                ['princess','topic','Princess']
              ];
              /* longest phrase first, so "sister in law" beats "sister" */
              var FQ_LIST = FQ_TERMS
                .filter(function (t) { return FQ_STYLE_TOPIC || (t[1] !== 'style' && t[1] !== 'topic'); })
                .map(function (t) { return { w: t[0].split(' '), g: t[1], v: t[2] }; })
                .sort(function (a, b) { return b.w.length - a.w.length; });
              var FQ_ORDER = ['who', 'age', 'stage', 'tone', 'style', 'topic', 'photos', 'occasion'];
              /* recipients also match on the singular stem, so sons → Son,
                 grandmas → Grandma, sisters → Sister, and "mum's" (which normalises
                 to "mums" once the apostrophe goes) → Mum */
              function fqStem(w) { return w.length > 3 && /s$/.test(w) ? w.slice(0, -1) : w; }
              function fqMilestone(n) {
                var t = n % 100, d = n % 10;
                var s = (t >= 11 && t <= 13) ? 'th' : (d === 1 ? 'st' : d === 2 ? 'nd' : d === 3 ? 'rd' : 'th');
                var v = n + s + ' birthday';
                return FQ_AGES.indexOf(v) >= 0 ? v : '';
              }
              function parseFacetQuery(q) {
                var text = String(q || '').toLowerCase().replace(/[\u2019']/g, '').replace(/&/g, ' and ')
                  .replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, '');
                var words = text ? text.split(' ') : [];
                var stems = words.map(fqStem);
                var sel = {}, coll = '', matched = 0, leftover = [], ages = [], i = 0;
                function take(g, v) {
                  if (!sel[g]) sel[g] = [];
                  if (sel[g].indexOf(v) < 0) { sel[g].push(v); matched++; }
                }
                while (i < words.length) {
                  var hit = null, len = 0;
                  for (var t = 0; t < FQ_LIST.length; t++) {
                    var ent = FQ_LIST[t], w = ent.w;
                    if (w.length > words.length - i) continue;
                    var ok = true;
                    for (var k = 0; k < w.length; k++) {
                      if (words[i + k] === w[k]) continue;
                      if (ent.g === 'who' && stems[i + k] === w[k]) continue;
                      ok = false; break;
                    }
                    if (ok) { hit = ent; len = w.length; break; }
                  }
                  if (hit) {
                    if (hit.g === 'occ') {
                      /* "50th wedding anniversary" is an anniversary, not a wedding */
                      if (!coll) { coll = hit.v; matched++; }
                      else if (coll === 'weddings' && hit.v === 'anniversary') coll = 'anniversary';
                    } else take(hit.g, hit.v);
                    i += len; continue;
                  }
                  var m = /^(\d{1,3})(?:st|nd|rd|th)$/.exec(words[i]);
                  var age = m ? fqMilestone(parseInt(m[1], 10)) : '';
                  if (age) { ages.push(age); i++; continue; }
                  if (FQ_STOPS.indexOf(' ' + words[i] + ' ') < 0) leftover.push(words[i]);
                  i++;
                }
                /* milestone tags live on birthday cards only, so the number in
                   "50th wedding anniversary" buys the collection and no age pill */
                if (!coll || coll === 'birthdays') { for (var a = 0; a < ages.length; a++) take('age', ages[a]); }
                return { coll: coll || 'birthdays', occ: !!coll, sel: sel, matched: matched, leftover: leftover, text: text };
              }
              function serialiseFacets(sel) {
                var out = [];
                for (var i = 0; i < FQ_ORDER.length; i++) {
                  var g = FQ_ORDER[i], vs = sel[g];
                  if (!vs || !vs.length) continue;
                  var enc = [];
                  for (var j = 0; j < vs.length; j++) enc.push(encodeURIComponent(vs[j]));
                  out.push(g + ':' + enc.join('|'));
                }
                return out.join(';');
              }
              var goneToCollection = false;
              if (form) form.addEventListener('submit', function (e) {
                var q = input.value.trim();
                if (goneToCollection || !q || scope || /product_type:/.test(q)) {
                  /* 23 Oct 2026: a scope is now the search TAB (?view=cards|gifts|flowers, the
                     alternate search templates — sections/ll-mp-filters.liquid), not a product_type
                     clause: Shopify's "-product_type:" matched every non-card product. */
                  if (scope && q && !/product_type:/.test(q) && SCOPE_Q[scope]) {
                    var vw = form.querySelector('input[name="view"]');
                    if (!vw) { vw = document.createElement('input'); vw.type = 'hidden'; vw.name = 'view'; form.appendChild(vw); }
                    vw.value = scope;
                  } else { var vw0 = form.querySelector('input[name="view"]'); if (vw0) vw0.remove(); }
                  return;
                }
                /* W4: a recognised filter intent goes to the pre-filtered collection.
                   Three things hold it back. More than one word left over means we
                   read the query badly ("happy birthday to my lovely neighbour").
                   Without an occasion, one facet value is not an intent — "sister",
                   "her", "photo" are searches, two values or more are a filter. And a
                   gift-line word vetoes it outright, occasion or not, because we sell
                   those products. The typed query rides along as ?fq= so the landing
                   page can still show it. */
                var fq = parseFacetQuery(q);
                var fqValues = fq.matched - (fq.occ ? 1 : 0);
                var fqGiftLine = FQ_GIFTY.test(fq.text);
                if (fq.leftover.length <= 1 && (fq.occ || fqValues >= 2) && !fqGiftLine) {
                  var mpf = serialiseFacets(fq.sel);
                  e.preventDefault();
                  goneToCollection = true;
                  try { window.vpbTrack && window.vpbTrack('search_facet_redirect', { q: q, coll: fq.coll, sel: fq.sel, leftover: fq.leftover }); } catch (err) {}
                  location.href = '/collections/' + fq.coll + '?' + (mpf ? 'mpf=' + mpf + '&' : '') + 'fq=' + encodeURIComponent(q);
                  return;
                }
                var rows = ps.querySelectorAll('[data-ps-collection]');
                for (var i = 0; i < rows.length; i++) {
                  if (collMatch(q, rows[i].getAttribute('data-ps-title'))) { e.preventDefault(); goneToCollection = true; location.href = rows[i].getAttribute('data-ps-url'); return; }
                }
                e.preventDefault();
                var done = false;
                var fallback = function () { if (done) return; done = true; goneToCollection = true; form.submit(); };
                var timer = setTimeout(fallback, 700);
                fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=4')
                  .then(function (r) { return r.json(); })
                  .then(function (j) {
                    if (done) return;
                    var cs = (j && j.resources && j.resources.results && j.resources.results.collections) || [];
                    for (var k = 0; k < cs.length; k++) {
                      if (collMatch(q, cs[k].title)) { done = true; clearTimeout(timer); goneToCollection = true; location.href = cs[k].url.replace(/\?.*$/, ''); return; }
                    }
                    clearTimeout(timer); fallback();
                  })
                  .catch(function () { clearTimeout(timer); fallback(); });
              });
              input.addEventListener('input', syncClear);
              syncClear();
              ps.addEventListener('focusout', function () {
                setTimeout(function () {
                  /* a tap inside the panel (suggestion row, scope pill, chip) blurs the input on
                     Safari/iOS before its click lands — keep the panel for that tap */
                  if (listTouch || Date.now() - (ps.__keep || 0) < 700) return;
                  if (!ps.contains(document.activeElement)) setFocused(false);
                }, 150);
              });
              ps.addEventListener('pointerdown', function (e) { var t = e.target && e.target.nodeType === 1 ? e.target : e.target && e.target.parentElement; if (t && t.closest('.vpb-search-home, .ll-ps__list, .predictive-search__list-item, .predictive-search, #predictive-search-results')) ps.__keep = Date.now(); }, true);
              /* Scrolling the suggestions on iPhone blurs the field when the touch ends: keep the panel while the list is touched or scrolling */
              var LIST_AREA = '.vpb-search-home, .ll-ps__list, .predictive-search, #predictive-search-results';
              var listTouch = false;
              function inList(e) { var t = e.target && e.target.nodeType === 1 ? e.target : e.target && e.target.parentElement; return !!(t && t.closest(LIST_AREA)); }
              ps.addEventListener('touchstart', function (e) { if (inList(e)) { listTouch = true; ps.__keep = Date.now(); } }, { passive: true, capture: true });
              ps.addEventListener('touchmove', function () { if (listTouch) ps.__keep = Date.now(); }, { passive: true, capture: true });
              ['touchend', 'touchcancel'].forEach(function (ev) { ps.addEventListener(ev, function () { if (listTouch) ps.__keep = Date.now(); listTouch = false; }, { passive: true, capture: true }); });
              ps.addEventListener('scroll', function () { ps.__keep = Date.now(); }, true);
              /* iPhone ignores overflow:hidden on the page: a drag outside a scrollable list scrolled the page and the header hid the panel */
              var dragY = 0;
              function scrollerFor(el) {
                for (var n = el; n && n !== ps.parentElement; n = n.parentElement) {
                  if (n.nodeType !== 1) continue;
                  var oy = getComputedStyle(n).overflowY;
                  if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
                }
                return null;
              }
              document.addEventListener('touchstart', function (e) { if (e.touches && e.touches[0]) dragY = e.touches[0].clientY; }, { passive: true, capture: true });
              var vv = window.visualViewport;
              function fitViewport() {
                if (!vv) return;
                var root = document.documentElement;
                if (root.classList.contains('vpb-search-open')) {
                  root.style.setProperty('--vpb-vvh', Math.round(vv.height) + 'px');
                  root.style.setProperty('--vpb-vvt', Math.round(vv.offsetTop) + 'px');
                } else {
                  root.style.removeProperty('--vpb-vvh');
                  root.style.removeProperty('--vpb-vvt');
                }
              }
              if (vv) { vv.addEventListener('resize', fitViewport); vv.addEventListener('scroll', fitViewport); }
              new MutationObserver(fitViewport).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
              document.addEventListener('touchmove', function (e) {
                if (!document.documentElement.classList.contains('vpb-search-open')) return;
                if (!e.cancelable || !e.touches || !e.touches[0]) return;
                var t = e.target && e.target.nodeType === 1 ? e.target : e.target && e.target.parentElement;
                var dy = e.touches[0].clientY - dragY;
                var sc = t && ps.contains(t) ? scrollerFor(t) : null;
                if (sc) {
                  var atTop = sc.scrollTop <= 0, atEnd = sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 1;
                  if (!((dy > 0 && atTop) || (dy < 0 && atEnd))) return;
                }
                e.preventDefault();
              }, { passive: false, capture: true });
              if (back) back.addEventListener('click', function (e) { e.preventDefault(); dismiss(); });
              if (clr) clr.addEventListener('click', function (e) {
                e.preventDefault();
                input.value = '';
                if (typeof ps.close === 'function') ps.close(true);
                syncClear(); input.focus();
              });
              function isLive() { return ps.hasAttribute('open') || ps.classList.contains('is-focused'); }
              function dismiss() {
                /* ps.dismiss() also drops any in-flight suggest request and blocks the
                   pending debounce, so nothing can re-open the list a moment later */
                if (typeof ps.dismiss === 'function') ps.dismiss();
                else if (typeof ps.close === 'function') ps.close(false);
                setFocused(false);
                syncClear();
                if (document.activeElement === input) input.blur();
              }
              /* Regions of the search element a tap must NOT dismiss: the field and its
                 buttons, the suggestions list, and the search-home panel (scope pills,
                 trending chips). Everything else inside the full-screen phone panel is
                 blank backdrop. */
              var KEEP = '.vpb-search-pill__field, .ll-ps__list, .predictive-search__list-item, .vpb-search-home, .vpb-search-pill__back, .vpb-search-pill__clear, .vpb-search-pill__btn, .vpb-sh__scope';
              /* Close search on a tap outside, not on a scroll. Phones keep the whole results panel open */
              var KEEP_PHONE = KEEP + ', .predictive-search, #predictive-search-results';
              var tapStart = null;
              document.addEventListener('pointerdown', function (e) {
                tapStart = isLive() ? { x: e.clientX, y: e.clientY, t: e.target } : null;
              }, true);
              document.addEventListener('pointercancel', function () { tapStart = null; }, true);
              document.addEventListener('pointerup', function (e) {
                var st = tapStart; tapStart = null;
                if (!st || !isLive()) return;
                if (Math.abs(e.clientX - st.x) > 10 || Math.abs(e.clientY - st.y) > 10) return;
                var t = st.t && st.t.nodeType === 1 ? st.t : (st.t && st.t.parentElement);
                if (!t || !t.isConnected) return;
                if (!ps.contains(t)) { dismiss(); return; }
                /* desktop: the list container is capped at 560px and scrolls — a scrollbar drag
                   targets the container itself, so keep it there */
                if (!t.closest(mq.matches ? KEEP_PHONE : KEEP + ', .predictive-search')) dismiss();
              }, true);
              document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && isLive()) { e.preventDefault(); dismiss(); }
              });
              window.addEventListener('blur', function () { if (isLive()) dismiss(); });
              ps.addEventListener('predictive-search:dismiss', function () { setFocused(false); syncClear(); });
            })();
